import React from 'react'
import { Box, SxProps } from '@mui/material'

export interface GlassLabelProps {
  /**
   * Label text to display
   */
  label: string
  /**
   * Additional styling
   */
  sx?: SxProps
}

/**
 * GlassLabel - Reusable glass effect label component
 *
 * Features:
 * - Frosted glass appearance
 * - Subtle shadow and inset highlight
 * - Rounded pill shape
 *
 * Used in: Quote, Emotion, and other visualizations
 */
export const GlassLabel: React.FC<GlassLabelProps> = ({ label, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '6px 16px',
        gap: '10px',
        background: 'rgba(255, 255, 255, 0.1)',
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.25), inset 0px -1px 1px #D1D7E3',
        borderRadius: '50px',
        fontFamily: 'Lexend Deca',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12.6px',
        lineHeight: '18px',
        color: '#FFFFFF',
        ...sx
      }}
    >
      {label}
    </Box>
  )
}

export default GlassLabel
